// i18n/setup.ts
import elEnLocale from 'element-plus/es/locale/lang/en'
import elZhLocale from 'element-plus/es/locale/lang/zh-cn'
import zh from './zh-cn.json'
import en from './en-us.json'
import { createI18n } from 'vue-i18n'
import { getLocale } from '../../i18n'

const messages = {
  en: {
    ...en,
    ...elEnLocale
  },
  'zh-cn': {
    ...zh,
    ...elZhLocale
  }
}

export const initI18n = () => {
  const locale = getLocale() || 'zh-cn'
  const i18n = createI18n({
    legacy: false,
    locale: locale, // 设置当前语言
    fallbackLocale: 'zh-cn', // 设置回退语言
    globalInjection: true, // 全局注册 $t 方法
    messages
  })
  return i18n
}
